'use strict';

module.exports = [
  '$window',
  '$parse',
  'DeviceServices',
  OnContextDirective];

function OnContextDirective($window, $parse, DeviceServices) {
  DeviceServices.isWebView();

  return function postLink($scope, $element, $attrs) {
    var handler;
    try {
      handler = $parse($attrs.onContext);
    } catch (error) {
      console.warn('onContext failed to parse method to call. Expected function as attribute. ' + $element);
      return
    }
    var onHold = $window.ionic.onGesture('hold', onHoldGesture, $element[0]);
    $element.on('contextmenu', onContextMenu);

    $scope.$on('$destroy', cleanup);

    function onContextMenu(e) {
      e.preventDefault();
      e.stopPropagation();

      $scope.$apply(function () {
        handler($scope, {$event: e});
      });

      return false;
    }

    function onHoldGesture(e) {
      e.preventDefault();
      e.stopPropagation();

      $scope.$apply(function () {
        handler($scope, {$event: e});
      });

      return false;
    }

    function cleanup() {
      $window.ionic.offGesture(onHold, 'hold', onHoldGesture);
      $element.off('contextmenu', onContextMenu);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/core-components/context-menu/OnContextDirective.js